import { lazy } from "react";
const Info004 = lazy(() => import("../pages/sys/sysApi/info004/Info004"));
const Info004Write = lazy(() => import("../pages/sys/sysApi/info004/Info004Write"));
const Info004WriteAsk = lazy(() => import("../pages/sys/sysApi/info004/Info004WriteAsk"));
const Info004View = lazy(() => import("../pages/sys/sysApi/info004/Info004View"));

const Info001 = lazy(() => import("app/pages/info/info001/Info001"));
const Info001Write = lazy(() => import("app/pages/info/info001/Info001Write"));
const Info001View = lazy(() => import("app/pages/info/info001/Info001View"));
const Info002 = lazy(() => import("app/pages/info/info002/Info002"));
const Info002Write = lazy(() => import("app/pages/info/info002/Info002Write"));
const Info003 = lazy(() => import("app/pages/info/info003/Info003"));
const TalkBoard = lazy(() => import("app/pages/info/talk/TalkBoard"));
const TalkBoardForm = lazy(() => import("app/pages/info/talk/TalkBoardForm"));
const TalkBoardView = lazy(() => import("app/pages/info/talk/TalkBoardView"));
const Info003Write = lazy(() => import("app/pages/info/info003/Info003Write"));
const Info003WriteAsk = lazy(() => import("app/pages/info/info003/Info003WriteAsk"));
const Info003View = lazy(() => import("app/pages/info/info003/Info003View"));
const ApiListBase = lazy(() => import("app/pages/sys/sysApi/apiList/ApiListBase"));
const ApiRequestList = lazy(() => import("app/pages/sys/sysApi/apiRequest/ApiRequestList"));
const ApiRequestDetail = lazy(() => import("app/pages/sys/sysApi/apiRequest/ApiRequestDetail"));
const CpInventoryBoard = lazy(() => import("app/pages/cp/inventory/InfoBoard"));

// 정보공개(공통)
export const infoRouter: any = [
  // 공지사항
  { path: "info/info001", element: <Info001 /> },
  { path: "info/info001/form", element: <Info001Write /> },
  { path: "info/info001/detail", element: <Info001View /> },

  // FAQ
  { path: "info/info002", element: <Info002 /> },
  { path: "info/info002/form", element: <Info002Write /> },

  // Q&A
  // 규제 기업 — 시장 참여 희망 기업 간 소통 게시판(#19).
  // 범용 게시판 pstat 의 분류 하나다(TALK). Q&A 와 달리 목록이 전원 공개이고
  // 댓글을 일반 사용자가 쓴다 — 서버가 그 분류에만 예외를 둔다.
  { path: "info/talk", element: <TalkBoard /> },
  { path: "info/talk/form", element: <TalkBoardForm /> },
  { path: "info/talk/detail", element: <TalkBoardView /> },

  { path: "info/info003", element: <Info003 /> },
  { path: "info/info003/form", element: <Info003Write /> },
  { path: "info/info003/write-ask", element: <Info003WriteAsk /> },
  { path: "info/info003/detail", element: <Info003View /> },

  // Open API
  { path: 'info/api/list', element: <ApiListBase /> },
  { path: 'info/api/status', element: <ApiRequestList /> },
  { path: 'info/api/status/detail', element: <ApiRequestDetail /> },

  { path: "info/api/info004", element: <Info004 /> },
  { path: "info/api/info004/form", element: <Info004Write /> },
  { path: "info/api/info004/write-ask", element: <Info004WriteAsk /> },
  { path: "info/api/info004/detail", element: <Info004View /> },

  // CP
  { path: 'info/cp/inventory', element: <CpInventoryBoard /> },
]